import { render, staticRenderFns } from "./manualAssignmentExaminationRoom.vue?vue&type=template&id=b1083918&scoped=true"
import script from "./manualAssignmentExaminationRoom.vue?vue&type=script&lang=js"
export * from "./manualAssignmentExaminationRoom.vue?vue&type=script&lang=js"
import style0 from "./manualAssignmentExaminationRoom.vue?vue&type=style&index=0&id=b1083918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1083918",
  null
  
)

export default component.exports